/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import DnsIcon from '@mui/icons-material/Dns';
import Tooltip from '@mui/material/Tooltip';
import * as redux from '../../../redux/constanst/index';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { llamadasEntrantes, llamadasErrores, llamadasSalientes, mapStateToProps} from '../models/buscar.js';
import ButtonGroup from '@mui/material/ButtonGroup';
import ListCalls from '../InicioFunctions/listCalls';
import ListDuration from '../InicioFunctions/listDuration';
import TransferList from '../InicioFunctions/transferList';
import SelectsTags from '../InicioFunctions/selectsTags';
import Selects from '../InicioFunctions/selects';
import SelectsFinal from '../InicioFunctions/selectsFinal';
import LoadScreen from '../../funtComponents/loadScreen';
import lodash from 'lodash';
import {
  Container,
  TopWrap,
  RowTitle,
  Title,
  Body,
  View
} from '../InicioFunctions/inicioElements';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));




function InicioPage(props) {
  
  const [entrantesState, setEntrantes] = React.useState([]);
  const [salientesState, setSalientes] = React.useState([]);
  const [loadEntrante, setLoadEntrante] = React.useState(true)
  const [loadSaliente, setLoadSaliente] = React.useState(true)
  const [llamantesUnicos, setLlamantesUnicos] = React.useState([])
  const [durEntrantes, setDurEntrantes] = React.useState();
  const [durSalientes, setDurSalientes] = React.useState();
  const [proEntrante, setProEntrante] = React.useState();
  const [proSalientes, setProSalientes] = React.useState();

  const dispatch = useDispatch();

  const [left] = useState([]);

  const [openLoad, setOpenLoad] = React.useState(false);

  const handlerSearch = async ( diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos) => {
    const errores =  llamadasErrores("nada", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
    if((typeof errores) !== "number"){
      dispatch({ type: redux.USER_ERRORSTATE_STATE_CHANGE, errorState: errores.mensaje })
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true })
      
    }
    if(errores === 200){
      
      dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })

      dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
      
      setOpenLoad(true);
      
      const respEntrantes = await llamadasEntrantes("entrantes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      const respSalientes = await llamadasSalientes("salientes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      if(respSalientes?.type === "SQL" || respEntrantes?.type === "SQL" ){
        handlerSearch(diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos)
        return
      }
      dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: respSalientes })
      
      dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: respEntrantes })

      setOpenLoad(false);
    }
    else{
      
    }
  
    
  
  } 

  const pushEntrantes = (e) => {
    let arrSrc = [];
    let arrDur = []
    if (loadEntrante === true) {
      const anexos = e;
      var arr = Object.entries(anexos);
      setEntrantes(arr)
      if (arr.length !== 0) {
        setLoadEntrante(false)
      }
      for (let i = 0; i < arr.length; i++) {
        arrSrc.push(arr[i][1]['dst'])
      }
      arrSrc = arrSrc.sort()
      for (let i = 0; i < arr.length; i++) {
        let valueDur = (arr[i][1]['duration'] / 60)
        arrDur.push(valueDur)
      }
      const newArray = new Set(arrSrc);
      setLlamantesUnicos(newArray.size);
      let sumEntrantes = lodash.sum(arrDur);
      setDurEntrantes(sumEntrantes);
      let proEntranteVal = (sumEntrantes / arr.length);
      setProEntrante(proEntranteVal)

    }

  }
  const pushSalientes = (e) => {


    if (loadSaliente === true) {

      let arrSrc = [];
      let arrDur = [];
      const anexos = e;
      var arr = Object.entries(anexos);
      setSalientes(arr)
      if (arr.length !== 0) {
        setLoadSaliente(false)
      }
      for (let i = 0; i < arr.length; i++) {
        arrSrc.push(arr[i][1]['dst'])
      }
      for (let i = 0; i < arr.length; i++) {
        let valueDur = (arr[i][1]['duration'] / 60)
        arrDur.push(valueDur)
      }
      arrSrc = arrSrc.sort()// [1, 5 ,9 , 8, 7, 1 ] [1, 1, 5 ,7, 8, 9]

      let sumSaliente = lodash.sum(arrDur);
      setDurSalientes(sumSaliente);
      let proSalientesVal = (sumSaliente / arr.length);
      setProSalientes(proSalientesVal)



    }
  }


  useEffect(() => {
    if(Object.entries(props.entrantes).length !== entrantesState.length){
      setLoadEntrante(true)
      pushEntrantes(props.entrantes)
    }
    if(Object.entries(props.salientes).length !== salientesState.length){
      setLoadSaliente(true)
      pushSalientes(props.salientes)
    }

    
    
  })


  return (
    <Container style={ContainerStyle}>
      <TopWrap>
        <RowTitle>
          <DnsIcon style={IconStyle} />
          <Tooltip title="Este es tu tablero personal" followCursor>
            <Title style={TitleOption}>
              Tablero
            </Title>
          </Tooltip>
        </RowTitle>
      </TopWrap>
      <Body>
        <Box sx={BodyStyle}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={5}>
              <Item>
                <View style={ItemTopBar}>
                  <Tooltip title="Seleccione una o más extensiones para filtrar" followCursor>
                    <h4 >Elija Extensiones</h4>
                  </Tooltip>
                </View>
                <View style={ItemExtBody}>
                  <TransferList list={left} />
                </View>
              </Item>
            </Grid>
            <Grid item xs={5}>
              <Item>
                <View style={DateContainer}>
                  <View style={ItemTopBar}>
                    <Tooltip title="Filtra anexos a través de rango horario" followCursor>
                      <h4 >Elija rango horario</h4>
                    </Tooltip>
                  </View>
                  <View style={DateTop}>
                    {<h4 >Atajos</h4>}
                    <Box sx={BoxTags}>
                      <ButtonGroup variant="outlined" aria-label="outlined button group">
                        <SelectsTags />
                      </ButtonGroup>
                    </Box>
                    <Button
                      style={SearchBtn}
                      onClick={() => handlerSearch(props.dateChangeInicio.dia, props.dateChangeInicio.mes, props.dateChangeFinal.dia, props.dateChangeFinal.mes, props.dateChangeInicio.year, props.dateChangeFinal.year, Object.values(props.rightAnexos) )}
                      variant="contained" color="success" >
                      <p style={{ fontSize: 10, }}  >Buscar</p>

                    </Button>
                  </View>
                  <View style={IniDate}>
                    <p style={{ marginTop: 15 }}>Fecha Inicial</p>
                    <Selects />
                  </View>
                  <View style={FinDate}>
                    <p style={{ marginTop: 5 }}>Fecha Final</p>
                    <SelectsFinal />
                  </View>
                  <View style={{ height: 20 }} />
                </View>
              </Item>
            </Grid>
            <Grid item xs={5} >
              <Item>
                <ListCalls listEntrantes={entrantesState} listSalientes={salientesState} listLlamantesUnicos={llamantesUnicos} />
              </Item>
            </Grid>
            <Grid item xs={5}>
              
              <Item>
                <ListDuration listDurEnrantes={durEntrantes} listSalientes={durSalientes} listProSaliente={proSalientes} listProEntrante={proEntrante} />
              </Item>
            </Grid>
          </Grid>
          <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad} />
        </Box>
        
      </Body>
   


      
    </Container >
  );
}





const ContainerStyle = {
  backgroundColor: "#f6f6f6",
}

const IconStyle = {
  marginLeft: 10,
  marginBottom: 10,
  color: 'rgba(229, 29, 29, 0.7)'
}

const TitleOption = {
  fontSize: 15,
}

const BodyStyle = {
  flexGrow: 1,
  width: '100%',
  height: '100%',
}

const ItemTopBar = {
  height: 50,
  display: 'flex',
  backgroundColor: 'lightgrey',
  alignItems: 'center',
  justifyContent: 'flex-start',
  alignContent: 'center',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20
}

const ItemExtBody = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
}

const DateContainer = {
  height: 'auto',
  display: 'flex',
  flexDirection: 'column'
}

const DateTop = {
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  alignContent: 'center',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20,
  marginTop: 12
}

const BoxTags = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& > *': {
    m: 1,
  },
}

const SearchBtn = {
  marginLeft: 30,
  background: 'rgba(229, 29, 29, 0.7)'
}

const IniDate = {
  height: 'auto',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20,
  flexDirection: 'column',
  marginTop: 10
}

const FinDate = {
  height: 'auto',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20,
  flexDirection: 'column',
  marginTop: 10,
  marginBottom: 10
}


export default connect(mapStateToProps, null)(InicioPage);